import {
  UIMODE_SET_MODE,
  UIModeAction,
  UIMODE_SET_TTS_MODE,
  UIMODE_SET_REGION_ZOOM_MODE,
  UIMODE_SET_TOOLBAR_DIRECTION,
  ToolbarDirection,
  UIMODE_SET_PAGES_IGNORE_POINTER_EVENTS,
} from '../actions/UIModeAction';
import { UIMode } from '../../../../common/src/ts/types/UIMode';

export interface UIModeState {
  mode: UIMode;
  ttsMode: boolean;
  regionZoomMode: boolean;
  toolbarDirection: ToolbarDirection;
  pagesIgnorePointerEvents: number;
}

export const initUIModeState = (): UIModeState => ({
  mode: UIMode.Touch,
  ttsMode: false,
  regionZoomMode: false,
  toolbarDirection: ToolbarDirection.Horizontal,
  pagesIgnorePointerEvents: 0,
});

function modeToIgnoreCount(prevMode: UIMode, newMode: UIMode) : -1 | 0 | 1 {
  if (prevMode === UIMode.Marker && newMode !== UIMode.Marker) {
    return -1;
  }
  if (prevMode !== UIMode.Marker && newMode === UIMode.Marker) {
    return 1;
  }
  return 0;
}

export const uimode = (state: UIModeState, action: UIModeAction): UIModeState => {
  switch (action.type) {
    case UIMODE_SET_MODE: {
      const pagesIgnorePointerEvents =
        state.pagesIgnorePointerEvents + modeToIgnoreCount(state.mode, action.mode);
      return { ...state, pagesIgnorePointerEvents, mode: action.mode };
    }
    case UIMODE_SET_TTS_MODE:
      return { ...state, ttsMode: action.ttsMode };
    case UIMODE_SET_REGION_ZOOM_MODE:
      return { ...state, regionZoomMode: action.enabled };
    case UIMODE_SET_TOOLBAR_DIRECTION:
      return { ...state, toolbarDirection: action.toolbarDirection };
    case UIMODE_SET_PAGES_IGNORE_POINTER_EVENTS: {
      const pagesIgnorePointerEvents = state.pagesIgnorePointerEvents + (action.enabled ? 1 : -1);
      return { ...state, pagesIgnorePointerEvents };
    }
  }
};
